module.exports = __webpack_public_path__ + "static/ENmobSlide6-87a5de29600b7fa45115610fbd985aab.jpg";